<template>
    <div
        class="animate-pulse rounded-md bg-taupe-200"
        role="presentation"
        aria-hidden="true"
    ></div>
</template>

<script>
export default {
    name: 'ZenSkeleton',
}
</script>
